import { SB } from '@play-co/replicant';

export const streakBattleRoyaleSchema = {
  streak: SB.object({
    /** Number of event completed */
    completeCount: SB.number(),
    /** Event intro popup seen flag of the ongoing event */
    introSeen: SB.boolean(),
    /** Timestamp in which the event will be reset to a new one */
    resetTimestamp: SB.number(),
    /** Timestamp in which the event has been joined */
    joinedTimestamp: SB.number().optional(),
    /** Timestamp in which user wins or fails the event */
    finishedTimestamp: SB.number().optional(),
    /** Last milestone that was seen on the frontend */
    lastMilestoneSeen: SB.int(),
    /** Current streak milestone of the ongoing event */
    milestone: SB.int(),
    /** Level streak at the time of joining the event */
    streakBeforeJoining: SB.int().optional(),
    /** Last User lifecycle, including completed, rewarded & failed */
    lastUserLifecycle: SB.string().optional(),
    /**
     * Status of the ongoing event.
     *
     * Using string instead of tuple to avoid having to migrate in the
     * case of adding and removing of statuses.
     *
     * Here are possible status lifecycle:
     * Losing: available -> active -> failed -> available -> and so on
     * Winning: available -> active -> completed -> rewarded
     * Expired: available -> active -> expired | available -> expired
     */
    status: SB.string(),
    /** Active event theme ID */
    theme: SB.string().default('lightning'),
    /** Active event player progression logic */
    progression: SB.string().default('basic'),
  }).optional(),
};
